module.exports = __webpack_public_path__ + "img/kplay_esport.61512907.jpg";